import React from 'react';
import PropTypes from 'prop-types';

import {
  getListingApplyURL,
} from 'common/listingHelpers';

import useBranch from 'client/hooks/useBranch';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';
import SrModalV2 from 'client/components/SrModalV2/SrModalV2';
import SrLinkUrlButton from 'client/components/SrLinkUrlButton';

const SrListingTenantScreeningApplyLinkModal = ({
  listing,
  onClose,
  showCloseButton,
}) => {
  const { appUrl } = useBranch({
    appUrl: ['env', 'APP_URL'],
  });
  const applyUrl = getListingApplyURL(listing, appUrl);

  return (
    <SrModalV2
      buttonTheme={SR_BUTTON_THEME_ADOBE_GREY}
      onClose={onClose}
      contentMaxWidth='587px'
      contentPadding='60px 30px 0'
      showCloseButton={showCloseButton}
    >
      <SrBox
        backgroundColor='white'
        padding='40px 24px'
        borderRadius='14px'
      >
        <SrFlex align='center' justify='center' direction='col'>
          <SrBox marginBottom='18px'>
            <img width='100px' height='auto' src='/images/share-link-blue.png' alt='share' />
          </SrBox>
          <SrBox marginBottom='16px'>
            <SrText
              color='blue'
              font='greycliff'
              weight='800'
              fontSize='26px'
              lineHeight='33px'
              display='block'
              align='center'
            >
              Please forward this link to all Applicants & Guarantors!
            </SrText>
          </SrBox>
          <SrText
            color='greyMonochrome'
            font='greycliff'
            weight='600'
            fontSize='16px'
            lineHeight='25px'
            display='block'
            align='center'
          >
            This link is saved in your portal. So no worries, you can always get this link later!
          </SrText>
        </SrFlex>
        <SrBox marginTop='33px' width='100%'>
          <SrLinkUrlButton
            href={applyUrl}
            buttonText='Copy Apply Link'
            className='linkUrlButtonBottom'
          />
        </SrBox>
        <SrBox marginTop='33px' width='100%'>
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_GREY}
            onClick={onClose}
          >
            Done
          </SrButton>
        </SrBox>
      </SrBox>
    </SrModalV2>
  );
};

SrListingTenantScreeningApplyLinkModal.propTypes = {
  listing: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  showCloseButton: PropTypes.bool,
};

SrListingTenantScreeningApplyLinkModal.defaultProps = {
  showCloseButton: false,
};

SrListingTenantScreeningApplyLinkModal.displayName = 'SrListingTenantScreeningApplyLinkModal';

export default SrListingTenantScreeningApplyLinkModal;
